import { Activity, ShieldCheck, Wifi, WifiOff } from "lucide-react";

type Props = {
  tenants: string[];
  current: string | null;
  onChange: (t: string) => void;
  connected: boolean;
};

export function Header({ tenants, current, onChange, connected }: Props) {
  return (
    <header className="border-b border-zinc-800 bg-zinc-950/70 backdrop-blur sticky top-0 z-10">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center gap-6">
        <a href="/" className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-brand-500 grid place-items-center">
            <svg viewBox="0 0 100 100" className="w-5 h-5">
              <path d="M25 30h50M25 50h50M25 70h50" stroke="#022c22" strokeWidth="10" strokeLinecap="round" fill="none" />
            </svg>
          </div>
          <div>
            <div className="text-base font-semibold leading-tight">ShelvesLab</div>
            <div className="text-[10px] uppercase tracking-widest text-brand-400">
              shelf telemetry · live
            </div>
          </div>
        </a>

        <div className="ml-auto flex items-center gap-4">
          <div className="hidden md:flex items-center gap-1.5 text-xs text-zinc-400">
            <ShieldCheck className="w-3.5 h-3.5 text-brand-400" />
            Zero-retention · k-thresholded · tenant-isolated
          </div>

          <label className="flex items-center gap-2 text-sm">
            <Activity className="w-4 h-4 text-zinc-400" />
            <select
              value={current ?? ""}
              onChange={(e) => onChange(e.target.value)}
              className="bg-zinc-900 border border-zinc-800 rounded-md px-3 py-1.5 text-sm focus:outline-none focus:border-brand-500"
            >
              {tenants.length === 0 && <option value="">(no tenants yet)</option>}
              {tenants.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
          </label>

          <div className="flex items-center gap-1.5 text-xs">
            {connected ? (
              <>
                <span className="w-2 h-2 rounded-full bg-brand-500 pulse-dot" />
                <Wifi className="w-3.5 h-3.5 text-brand-400" />
                <span className="text-brand-300">live</span>
              </>
            ) : (
              <>
                <span className="w-2 h-2 rounded-full bg-zinc-600" />
                <WifiOff className="w-3.5 h-3.5 text-zinc-500" />
                <span className="text-zinc-500">offline</span>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
